import { AppState } from "../../store";

//Selectors that pull values from state.
export const selectCurrentVersion = (state: AppState) => state.reducer.System.currentVersion;
export const selectAllowRefresh = (state: AppState) => state.reducer.System.allowRefresh;



